import { render, staticRenderFns } from "./SaTabsScrollComponent.vue?vue&type=template&id=fdf1f2a2"
import script from "./SaTabsScrollComponent.vue?vue&type=script&lang=js"
export * from "./SaTabsScrollComponent.vue?vue&type=script&lang=js"
import style0 from "./SaTabsScrollComponent.vue?vue&type=style&index=0&id=fdf1f2a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports